import React, { useState } from "react"

export const BookModalContext = React.createContext({})

export const BookModalContextProvider = ({ children }) => {
  const [bookingId, setBookingId] = useState("H57H020493")
  const [isOpen, setIsOpen] = useState(false)

  return (
    <BookModalContext.Provider
      value={{ bookingId, setBookingId, isOpen, setIsOpen }}
    >
      {children}
    </BookModalContext.Provider>
  )
}
